import { render, staticRenderFns } from "./doubleCall.vue?vue&type=template&id=4b77ec32&"
import script from "./doubleCall.vue?vue&type=script&lang=js&"
export * from "./doubleCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports